import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    IconButton,
    Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function DynamicBasicDialog({ open, onClose, onConfirm, title, content, confirmButtonText }) {
    // Determine confirm button text
    let confirmText = "Archive";
    if (confirmButtonText) {
        confirmText = confirmButtonText;
    } else if (title === "Logout Confirmation" || title === "Confirmation") {
        confirmText = "Yes";
    } else if (title && title.toLowerCase().includes("unarchive")) {
        confirmText = "Unarchive";
    }

    // Determine if this is an unarchive action for button color
    const isUnarchiveAction = confirmText === "Unarchive" || 
        (title && title.toLowerCase().includes("unarchive")) ||
        (confirmButtonText && confirmButtonText.toLowerCase().includes("unarchive"));

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle
                sx={{ m: 0, p: 2, textAlign: 'center', position: 'relative' }}
            >
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <DialogContentText sx={{ textAlign: 'center' }}>{content}</DialogContentText>
            </DialogContent>
            {
                title !== "Warning" ?
                    <DialogActions sx={{ justifyContent: 'center' }}>
                        <Button onClick={onClose} variant="outlined">{title === "Logout Confirmation" || title === "Confirmation" ? "No" : "Cancel"}</Button>
                        <Button 
                            onClick={onConfirm} 
                            variant="contained" 
                            color={isUnarchiveAction ? "success" : "error"}
                        >
                            {confirmText}
                        </Button>
                    </DialogActions>
                    :
                    <DialogActions sx={{ justifyContent: 'center' }}>
                        <Button onClick={onClose} variant="outlined">{title === "Logout Confirmation" || title === "Confirmation" ? "No" : title === "Warning" ? "Ok" : "Cancel"}</Button>
                    </DialogActions>
            }
        </Dialog>
    );
}

export default DynamicBasicDialog;
